import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { TRIAL_BALANCE_REPORT_API } from "./apiRoutes";

interface UseGetOwnerTrialBalanceLineItemReportProps {
  ownerId: string;
  filter: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getOwnerTrialBalanceLineItemReport = async (ownerId: string, filter: any) =>
  await axiosAuth.get(`${TRIAL_BALANCE_REPORT_API(filter?.communityId)}/customer/${ownerId}/line-items?${new URLSearchParams(filter).toString()}`);

const useGetOwnerTrialBalanceLineItemReport = ({
  ownerId,
  filter,
  queryParams,
}: UseGetOwnerTrialBalanceLineItemReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["owner-trial-balance-line-item-report", ownerId],
    queryFn: () => getOwnerTrialBalanceLineItemReport(ownerId, filter),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetOwnerTrialBalanceLineItemReport;
